import React from 'react';

import { flagStyles } from '../settings';

const SvgZW = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5904px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgZW;
